<template>
  <div :class="[$style.formcon,'formcon']">
    <div :class="$style.enterInfo">
      <div :class="$style.tips">注：此申請表為試行版本，入會形式及方式後期可能發生改變！另，2021年度會費免收取！</div>
      <div v-for="(item,index) in questionRes" :key="index">
        <div v-if="item.type=='file'" :class="$style.upImg">
          <h3>{{(index+1)<10?('0'+(index+1)):index+1}} {{item.title}}<i v-if="item.isRequest" :class="$style.note">*</i></h3>
          <a :href="application_cert_url" target="_blank">{{application_cert_url}}</a>
          <img @click="fnSubmitImg('uploadfile')" ref="ApplicationPhoto" :src="custom_joinasso_apply[item.key]?custom_joinasso_apply[item.key]:'https://www.sztmas.cn/sztx/assets/images/edit-bg.png'"/>
          <input style="display: none;" ref="uploadfile" name="application_cert" @change="uploadfile" type="file"/>
        </div>
        <div v-if="item.type=='pic'" :class="$style.upImg">
          <h3>{{(index+1)<10?('0'+(index+1)):index+1}} {{item.title}}<i v-if="item.isRequest" :class="$style.note">*</i></h3>
          <img @click="fnSubmitImg(item.eventName)" :ref="item.ref" :src="custom_joinasso_apply[item.key]?custom_joinasso_apply[item.key]:'https://www.sztmas.cn/sztx/assets/images/mtpNo.png'"/>
          <input style="display: none;" :ref="item.eventName" :name="item.key" @change="uploadfile" type="file"/>
        </div>
        <el-row  v-if="item.type=='radio'">
          <el-col :span="24">
            <label>{{(index+1)<10?('0'+(index+1)):index+1}} {{item.title}}<i v-if="item.isRequest" :class="$style.note">*</i></label>
          </el-col>
          <el-col :span="24" v-if="item.key=='isHasPreCompany'">
            <el-radio-group v-model="isHasPreCompany">
              <el-radio v-for="(it,idx) in item.childChoice" :key="idx" :name="it.con" :label="it.val">{{it.con}}</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="24" v-else>
            <el-radio-group v-model="custom_joinasso_apply[item.key]">
              <el-radio v-for="(it,idx) in item.childChoice" :key="idx" :name="it.val" :label="it.val">{{it.con}}</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row v-if="item.type=='text'">
          <el-col :span="24">
            <label>{{(index+1)<10?('0'+(index+1)):index+1}} {{item.title}}<i v-if="item.isRequest" :class="$style.note">*</i></label>
          </el-col>
          <el-col :span="24">
            <input type="text" v-model="custom_joinasso_apply[item.key]" placeholder="請輸入" />
          </el-col>
        </el-row>
      </div>
      <div :class="$style.upImg">
        <h3>{{questionRes.length+1}} 擬加入總會的聯誼會/婦女會/青年會/慢壘聯盟？<i :class="$style.note">*</i></h3>
        <el-radio-group v-model="join_child_association">
          <el-radio label="聯誼會">聯誼會</el-radio>
          <el-radio label="婦女會">婦女會</el-radio>
          <el-radio label="青年會">青年會</el-radio>
          <el-radio label="慢壘聯盟">慢壘聯盟</el-radio>
        </el-radio-group>
      </div>
      <el-row v-show="isSowChildAssociation">
        <el-col :span="24">
          <label>{{questionRes.length+2}} 哪個聯誼會？<i :class="$style.note">*</i></label>
        </el-col>
        <el-col :span="24">
          <input type="text" v-model="custom_joinasso_apply.join_child_association" placeholder="哪個聯誼會？" />
        </el-col>
      </el-row>
    </div>
    
    <footer>
      <button @click="fnSubmit" v-if="submitStatus==0">提交</button>
      <button @click="fnUpdateSubmit" v-if="submitStatus==1">修改</button>
      <button :class="$style.gray"  v-if="submitStatus==2">審核通過</button>
    </footer>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import * as qiniu from 'qiniu-js';

export default {
  components: {
  },
  data() {
    return {
      application_cert_url:'http://qn.ts960.com/深圳台商协会入会申请公函.docx',
      association_id: 'SZTX',
      submitStatus:0,
      qiniuToken: '',
      isHasPreCompany:'',//是否有母公司
      //填写是哪个联谊会，即当custom_joinasso_apply.join_child_association=‘联谊会’时才显示
      isSowChildAssociation:false,
      join_child_association:'',
      // 各种图片存储
      application_cert:'',
      cer_one:'',
      personal_photo:'',
      taibao_frontview:'',
      taibao_reverse:'',
      custom_joinasso_apply:{
        apply_type:1,//申请类型（默认0,0个人；1企业）
        member_id:'',
        association_id: this.association_id,
        application_cert:'',
        isnewmember:'',
        company_name:'',
        company_name_en:'',
        cer_one:'',
        setup_date:'',
        field:'',
        econ_kind:'',
        main_businee:'',
        company_add:'',
        company_phone:'',
        company_fax:'',
        company_url:'',
        company_email:'',
        registered_capital:'',
        ice_phone:'',
        ice_people:'',
        isHasPreCompany:'',
        p_company_name:'',
        p_company_phone:'',
        p_company_add:'',
        p_company_contacts:'',
        member_name:'',
        personal_photo:'',
        company_job:'',
        member_phone:'',
        member_address:'',
        taibao_frontview:'',
        taibao_reverse:'',
        join_child_association:'',
      },
      questionRes:[
        {
          type:'file',
          title:'下載入會申請公函，蓋章簽字後，掃描或拍照上傳',
          key:'application_cert',
          isRequest:true
        },
        {
          type:'radio',
          title:'您是否是新會員?',
          key:'isnewmember',
          isRequest:true,
          childChoice:[
            {
              con:'是',
              val:0
            },{
              con:'不是',
              val:1
            }
          ]
        },
        {
          type:'text',
          title:'公司名稱（中文）',
          key:'company_name',
          isRequest:true
        },
        {
          type:'text',
          title:'公司名稱（英文）',
          key:'company_name_en',
          isRequest:false
        },
        {
          type:'pic',
          title:'上傳營業執照照片',
          key:'cer_one',
          ref:'cerOneFile',
          eventName:'cerOne',
          isRequest:true
        },
        {
          type:'text',
          title:'成立日期',
          key:'setup_date',
          isRequest:true
        },
        {
          type:'radio',
          title:'所屬行業',
          key:'field',
          childChoice:[
            {
              con:'工業',
              val:'工業'
            },{
              con:'農業',
              val:'農業'
            },{
              con:'金融證券',
              val:'金融證券'
            },{
              con:'服務業',
              val:'服務業'
            },{
              con:'其他',
              val:'其他'
            }
          ],
          isRequest:true
        },
        {
          type:'radio',
          title:'企業性質',
          key:'econ_kind',
          childChoice:[
            {
              con:'獨資',
              val:'工獨資業'
            },{
              con:'合資合作',
              val:'合資合作'
            },{
              con:'來料加工',
              val:'來料加工'
            },{
              con:'其他',
              val:'其他'
            }
          ],
          isRequest:true
        },
        {
          type:'text',
          title:'企業產品或經營範圍介紹',
          key:'main_businee',
          isRequest:true
        },
        {
          type:'text',
          title:'公司地址',
          key:'company_add',
          isRequest:true
        },
        {
          type:'text',
          title:'公司電話',
          key:'company_phone',
          isRequest:true
        },
        {
          type:'text',
          title:'公司傳真',
          key:'company_fax',
          isRequest:false
        },
        {
          type:'text',
          title:'企業網址',
          key:'company_url',
          isRequest:false
        },
        {
          type:'text',
          title:'電子郵箱',
          key:'company_email',
          isRequest:true
        },
        {
          type:'text',
          title:'投資規模（資金金額及幣種）',
          key:'registered_capital',
          isRequest:true
        },
        {
          type:'text',
          title:'緊急情況聯絡人',
          key:'ice_phone',
          isRequest:true
        },
        {
          type:'text',
          title:'緊急情況聯絡人電話',
          key:'ice_people',
          isRequest:true
        },
        {
          type:'radio',
          title:'是否有台灣母公司？',
          key:'isHasPreCompany',
          childChoice:[
            {
              con:'有',
              val:1,
            },{
              con:'否',
              val: 0
            }
          ],
          isRequest:true
        },
      ],
      // 选择有母公司需要填写的信息
      hasCompanyRes:[
        {
          type:'text',
          title:'公司名稱',
          key:'p_company_name',
          isRequest:true
        },
        {
          type:'text',
          title:'電話',
          key:'p_company_phone',
          isRequest:true
        },
        {
          type:'text',
          title:'地址',
          key:'p_company_add',
          isRequest:true
        },
        {
          type:'text',
          title:'聯絡人',
          key:'p_company_contacts',
          isRequest:true
        },
      ],
      //选择是/否有母公司后显示
      showPreCompanyRes:[
        {
          type:'text',
          title:'代表人姓名',
          key:'member_name',
          isRequest:true
        },
        {
          type:'pic',
          title:'個人照片（2寸）',
          key:'personal_photo',
          ref:'personalPhotofile',
          eventName:'personalPhoto',
          isRequest:true
          // name:'personal_photo'
        },
        {
          type:'text',
          title:'代表人任職情況',
          key:'company_job',
          isRequest:true
        },
        {
          type:'text',
          title:'代表人移動電話',
          key:'member_phone',
          isRequest:true
        },
        {
          type:'text',
          title:'代表人住址',
          key:'member_address',
          isRequest:true
        },
        {
          type:'pic',
          title:'上傳台胞證或居住證（正面照片）',
          key:'taibao_frontview',
          ref:'taibaoFrontviewFile',
          eventName:'taibaoFrontview',
          isRequest:true
        },
        {
          type:'pic',
          title:'上傳台胞證或居住證（反面照片）',
          key:'taibao_reverse',
          ref:'taibaoFeverseFile',
          eventName:'taibaoFeverse',
          isRequest:true
        }
      ]
    }
  },
  computed: {
    ...mapState(['isPc','userInfo','user_id',"validToken"]),
  },
  watch: {
    join_child_association(val, old) {
      // console.log(val);
      // console.log(old);
      this.isSowChildAssociation = val == "聯誼會" ? true : false;
      if (val !== "聯誼會") {
        this.custom_joinasso_apply.join_child_association = val;
      }
      if(this.isSowChildAssociation){
        if(old=='婦女會'||old=='青年會'||old=='慢壘聯盟'){
          this.custom_joinasso_apply.join_child_association = "";
        }

      }
      // if (old !== "聯誼會" && val == "聯誼會") {
      //   this.custom_joinasso_apply.join_child_association = "";
      // }
    },
    isHasPreCompany(val){
      // console.log(val)
        this.questionRes=this.questionRes.filter((item,index) => index <18)
      if(val==1){
        // console.log(this.questionRes.filter((item,index) => index <17))
        var newA = [...this.hasCompanyRes,...this.showPreCompanyRes];
        newA.unshift(18, 0);
        Array.prototype.splice.apply(this.questionRes, newA); 
      }else if(val==0){
        this.showPreCompanyRes.unshift(18, 0);
        Array.prototype.splice.apply(this.questionRes, this.showPreCompanyRes); 
      }
    },
    validToken(val) {
      this.$store.state.isDialogVisible = !val ? true : false;
    },
    user_id(val){
      this.checkInfo();
    }
  },
  methods: {
    fnSubmitImg(type) {
      this.$refs[type][0].click();
    },
    uploadfile(e) {
      let vm = this;
      vm[e.target.name] = e.target.files[0];
      let name=e.target.name
      var reader = new FileReader();
      reader.readAsDataURL(vm[e.target.name]);
      reader.onload = function (e) {
        // vm.$refs.personalPhotofile[0].src = this.result;
        vm.submitPic(name)
      };
    },
    async fnSubmit() {
      let applyRes = this.custom_joinasso_apply;
      if (
        !applyRes.application_cert ||
        applyRes.isnewmember=='null' ||
        !applyRes.member_name ||
        !applyRes.company_name ||
        !applyRes.cer_one ||
        !applyRes.setup_date ||
        !applyRes.field ||
        !applyRes.econ_kind ||
        !applyRes.main_businee ||
        !applyRes.company_add ||
        !applyRes.company_phone ||
        !applyRes.company_email ||
        !applyRes.registered_capital ||
        !applyRes.ice_people ||
        !applyRes.ice_phone ||
        !applyRes.personal_photo ||
        !applyRes.company_job ||
        !applyRes.member_phone ||
        !applyRes.member_address ||
        !applyRes.taibao_frontview ||
        !applyRes.taibao_reverse ||
        !applyRes.join_child_association
      ){
        return this.$message.error('請填完必填項再提sss交！');
      }
      
      // 有母公司必填
      if(this.isHasPreCompany==1){
        if(
          !applyRes.p_company_name ||
          !applyRes.p_company_phone ||
          !applyRes.p_company_add ||
          !applyRes.p_company_contacts 
        ){
          return this.$message.error("請填完必填項再提交！");

        }
      }else{
        applyRes.p_company_name=''
        applyRes.p_company_phone=''
        applyRes.p_company_add=''
        applyRes.p_company_contacts=''
      }
      this.custom_joinasso_apply.event='add'
      this.custom_joinasso_apply.association_id = this.association_id;
      this.custom_joinasso_apply.member_id = this.user_id;
      this.custom_joinasso_apply.isHasPreCompany = this.isHasPreCompany;

      const { data: res } = await this.$http.post(`/api/v2/association/coustomJoin`,this.custom_joinasso_apply)
      if(!res.sucess) return this.$message.error('獲取失敗')
      if(res.code==200){
        this.$message.success("申請成功");
        this.submitStatus = 1;
      }
    },
    async fnUpdateSubmit(){
      let applyRes = this.custom_joinasso_apply;
      if (
        !applyRes.application_cert ||
        applyRes.isnewmember=='null' ||
        !applyRes.member_name ||
        !applyRes.company_name ||
        !applyRes.cer_one ||
        !applyRes.setup_date ||
        !applyRes.field ||
        !applyRes.econ_kind ||
        !applyRes.main_businee ||
        !applyRes.company_add ||
        !applyRes.company_phone ||
        !applyRes.company_email ||
        !applyRes.registered_capital ||
        !applyRes.ice_people ||
        !applyRes.ice_phone ||
        !applyRes.personal_photo ||
        !applyRes.company_job ||
        !applyRes.member_phone ||
        !applyRes.member_address ||
        !applyRes.taibao_frontview ||
        !applyRes.taibao_reverse ||
        !applyRes.join_child_association
      ){
        return this.$message.error('請填完必填項再提sss交！');
      }
      
      // 有母公司必填
      if(this.isHasPreCompany==1){
        if(
          !applyRes.p_company_name ||
          !applyRes.p_company_phone ||
          !applyRes.p_company_add ||
          !applyRes.p_company_contacts 
        ){
          return this.$message.error("請填完必填項再提交！");

        }
      }else{
        applyRes.p_company_name=''
        applyRes.p_company_phone=''
        applyRes.p_company_add=''
        applyRes.p_company_contacts=''
      }
      this.custom_joinasso_apply.association_id = this.association_id;
      this.custom_joinasso_apply.member_id = this.user_id;
      this.custom_joinasso_apply.isHasPreCompany = this.isHasPreCompany;
      const { data: res } = await this.$http.post(`/api/v2/association/updataCoustomJoin`,this.custom_joinasso_apply)
      if(!res.sucess) return this.$message.error('獲取失敗')
      if(res.code==200){
        this.$message.success("修改成功");
        // this.submitStatus = 2;
      }
    },
    // 上传图片到七牛云
    submitPic(type){
      let vm = this;
      let file = vm[type];
      let key = Date.now() + '_' + Math.random();
      var putExtra = {
        fname: vm[type].name
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0
      };
      let observer = {
        next(res){
          // ...
        },
        error(err){
          vm.$message.error(err);
        },
        complete(res){
          vm.custom_joinasso_apply[type] = vm.$imgUrl + res.key
        }
      }
      var observable = qiniu.upload(file, key, vm.qiniuToken, putExtra, config)
      var subscription = observable.subscribe(observer) // 上传开始
    },
    async getQiniuToken() {
      const { data: res } = await this.$http.get(`/api/v2/qiniu/getUptoken`)
      if(!res.sucess) return this.$message.error('獲取失敗')
      this.qiniuToken=res.data
    },
    // 检查是否已经申请入会
    async checkInfo(){
      const { data: res } = await this.$http.post(`/api/v2/association/coustomJoin`,{
          member_id:this.user_id,
          apply_type:1,//申请类型（默认0,0个人；1企业）
          event:'select'
        })
      if(!res.sucess) return this.$message.error('獲取失敗')
      if (res.data && res.data.length > 0) {
        this.custom_joinasso_apply = res.data[0];
        if(this.custom_joinasso_apply.join_child_association!=='婦女會'&&this.custom_joinasso_apply.join_child_association!=='青年會'&&this.custom_joinasso_apply.join_child_association!=='慢壘聯盟'){
          this.isSowChildAssociation=true
          this.join_child_association='聯誼會'
        }else{
          this.join_child_association=this.custom_joinasso_apply.join_child_association
        }
        if(this.custom_joinasso_apply.p_company_name){
          this.isHasPreCompany=1
        }else{
          this.isHasPreCompany=0
        }
        if (res.data[0].isreview == 1) {
          this.submitStatus = 2;
        } else {
          this.submitStatus = 1;
        }
        if (!res.data[0].application_cert||res.data[0].application_cert==null||res.data[0].application_cert=='null') {
          this.submitStatus = 0;
        }

      }else{
          this.submitStatus = 0;
      }
    }
  },
  created() {
    let vm = this;
    this.getQiniuToken()
    if(this.user_id){
      this.checkInfo();
    }
  },
  mounted(){
    if(!this.validToken){
      this.$store.state.isDialogVisible = true
    }
  }
}
</script>

<style module>
  .formcon{
    padding: 35px 0;
    background: #fff;
    width: 650px;
    max-width: 90%;
    margin: auto;
  }
  .tips{
    color: #F12E2B;
    font-size: 16px;
  }
  .formcon label {
    line-height: 30px;
    font-size: 18px;
    color: #333;
    font-family: 'Helvetica Neue';
  }
  .formcon .enterInfo input,.formcon .enterInfo .choose_area{
    border: 2px solid #dee1e4;
    border-radius: 8px;
    padding-left: 8px;
    height: 30px;
    font-size: 16px;
    width: 95%;
  }
  .formcon .enterInfo .choose_area span{
    line-height: 30px;
    color: #757575;
  }
  .formcon .enterInfo .note {
    color: #f12e2b;
    font-size: 17px;
    margin-left: 9px;
  }
  .upImg h3 {
    padding: 8px 0;
    font-size: 18px;
    font-weight: normal;
    color: #333;
  }
  .upImg a{
    color: rgba(53,165,249,1);
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .upImg img {
    width: 80%;
    margin: 20px auto;
    border-radius: 4px;
    max-width: 100%;
    display: block;
    height: 140px;
    object-fit: contain;
  }
  .notice {
    text-align: center;
    line-height: 30px;
    font-size: 18px;
    margin-top: 10px;
  } 
  .notice a {
    text-decoration: underline;
  }
  .formcon footer{
    box-sizing: border-box;
    position: static;
    width: 100%;
    padding: 6px 0;
  }
  .formcon footer button {
    border-radius: 25px;
    border: none;
    background: #F12E2B;
    box-shadow: 0 0 20px 0 rgba(241,46,43,0.20), 0 8px 10px 0 rgba(241,46,43,0.30);
    padding: 12px 0 15px;
    color: #ffffff;
    font-size: 16px;
    line-height: 22px;
    width: 50%;
    margin:20px auto;
    display: block;
  }
  .formcon footer .gray{
    background: #eeeeee;
    box-shadow:none
  }
</style>
<style>
  .formcon .el-row {
    padding: 8px 0;
    /* display: flex; */
    align-items: center;
  }
  .formcon .el-radio__icon{
    font-size:18px
  }
  .formcon .el-radio--horizontal{
    margin-right: 10px;
  }
  .formcon .el-radio__label{
    margin-left: 8px;
    line-height: 27px;
  }
</style>

